import { render } from "./enterpriseDynamics.vue?vue&type=template&id=612270ac"
import script from "./enterpriseDynamics.vue?vue&type=script&lang=js"
export * from "./enterpriseDynamics.vue?vue&type=script&lang=js"

import "./enterpriseDynamics.vue?vue&type=style&index=0&id=612270ac&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__